import React, { useContext, useEffect, useState } from "react";
import ContentSection from "../../Content";
import { UserContext } from "../../../utils/User_check";
import SwalTopEnd from "../../../utils/swal_top_end";
import { icon } from "leaflet";
import axios from "axios";
import BaseUrl from "../../../utils/BaseUrl";

const url = BaseUrl();
const PageProfil = () => {

    const {user,permissions, societe} = useContext(UserContext);
    const [loading,setLoading] = useState(false);


  const [passwords, setPasswords] = useState({
    current: "",
    new: "",
    confirm: "",
  });


    useEffect(()=>{
       
    },[user,permissions]);


  const handlePasswordChange = (e) => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value });
  };

  const submitPasswordChange = () => {
    if(passwords.current === ""){SwalTopEnd({icon:"error", title:"Veuillez saisir le mot de passe actuel"});return;}
    if(passwords.new === ""){SwalTopEnd({icon:"error", title:"Veuillez saisir le nouveau mot de passe "});return;}
    if(passwords.confirm === ""){SwalTopEnd({icon:"error", title:"Veuillez confirmer le nouveau mot de passe"});return;}
    if (passwords.new !== passwords.confirm) {SwalTopEnd({icon:"error", title:"Les mots de passe ne correspondent pas !"});
      return;
    }

    const _formData = {
        current:passwords.current,
        new:passwords.new,
        new_confirmation:passwords.confirm
    }
    setLoading(true);
    try {
        axios.post(url.base+'/password-modify',_formData,
        {
            headers:{
                'Content-Type':'multipart/form-data',
                "Authorization": `Bearer ${localStorage.getItem('_token_')}`                   
            },
            credentials:'include'
        }
        ).then((resp)=>{          
            setLoading(false);
            
            SwalTopEnd({icon:"success",title:"Mot de passe modifié avec succès."});
            window.$("#passwordModal").modal('hide');
            
        }).catch((error)=>{
        setLoading(false);
        });
    } catch (error) {
        let message = "Une erreur est subvenue.";
        if (error.response) {
            message = error?.response?.data?.message ;
        } else if (error.request) {
            message = "Le serveur ne répond pas. Vérifie ta connexion Internet.";
        } else {
            message = error?.message;
        }

         SwalTopEnd({icon:"error",title:message});
         setLoading(false);
    }

    // Reset
    setPasswords({ current: "", new: "", confirm: "" });
  };

  return (
    <ContentSection ulShownav="parametres" navactive="mon-compte">
        <div className="container mt-4">
        <h3 className="text-center fw-bold mb-4">Mon profil</h3>

        <div className="card shadow-sm">
            <div className="card-body">
            <h5 className="card-title mb-3">Informations personnelles</h5>

            <div className="row mb-2">
                <div className="col-sm-6">
                <p><strong>Nom :</strong> {user?.use_nom}</p>
                </div>
                <div className="col-sm-6">
                <p><strong>Prénoms :</strong> {user?.use_prenom}</p>
                </div>
                <div className="col-sm-6">
                <p><strong>Téléphone :</strong> {user?.phone}</p>
                </div>
                <div className="col-sm-6">
                <p><strong>Email :</strong> {user?.email}</p>
                </div>
                <div className="col-sm-6">
                <p><strong>Société :</strong> {societe?.name}</p>
                </div>
                <div className="col-sm-6">
                <p><strong>Statut :</strong> 

                        {user?.is_active === 1 && (
                            <span className="badge bg-success mx-3"> ✅ Actif</span>
                        )}
                        {user?.is_active === 0 && (
                            <span className="badge bg-danger mx-3">❌ Terminé</span>
                        )}
                </p>
                </div>
            </div>

            <button
                className="btn btn-primary mt-3"
                data-bs-toggle="modal"
                data-bs-target="#passwordModal"
            >
                Modifier le mot de passe
            </button>
            </div>
        </div>

        {/* MODAL BOOTSTRAP */}
        <div
            className="modal fade"
            id="passwordModal"
            tabIndex="-1"
            aria-labelledby="passwordModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog">
            <div className="modal-content">
                <div className="modal-header">
                <h5 className="modal-title" id="passwordModalLabel">
                    Modifier le mot de passe
                </h5>
                <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                ></button>
                </div>

                <div className="modal-body">
                <div className="mb-3">
                    <label className="form-label">Mot de passe actuel</label>
                    <input
                    type="password"
                    name="current"
                    className="form-control"
                    value={passwords.current}
                    onChange={handlePasswordChange}
                    />
                </div>

                <div className="mb-3">
                    <label className="form-label">Nouveau mot de passe</label>
                    <input
                    type="password"
                    name="new"
                    className="form-control"
                    value={passwords.new}
                    onChange={handlePasswordChange}
                    />
                </div>

                <div className="mb-3">
                    <label className="form-label">Confirmer le nouveau mot de passe</label>
                    <input
                    type="password"
                    name="confirm"
                    className="form-control"
                    value={passwords.confirm}
                    onChange={handlePasswordChange}
                    />
                </div>
                </div>

                <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                >
                    Fermer
                </button>
                <button
                    type="button"
                    className="btn btn-success"
                    onClick={submitPasswordChange}
                >
                    Valider
                </button>
                </div>
            </div>
            </div>
        </div>
        </div>
    </ContentSection>
    
  );
};

export default PageProfil;
